export const isLastIndex = (index, array) => {
    if (index === array.length - 1) {
        return true;
    }
    return false;
};
